(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('announcement-bar')) {
    customElements.define(
      'announcement-bar',
      class extends HTMLElement {
        connectedCallback() {
          this.messages = Array.from(this.querySelectorAll('[data-announcement-message]')).filter((message) => {
            return message.textContent.trim().length > 0;
          });
          const activeIndex = this.messages.findIndex((message) => message.classList.contains('is-active'));
          this.index = activeIndex > -1 ? activeIndex : 0;
          this.hovering = false;
          this.focused = false;
          this.editorPaused = false;
          this.timer = null;
          this.seconds = Number(this.dataset.changeEvery) || 5;

          this.onEnter = () => {
            this.hovering = true;
            this.stop();
          };
          this.onLeave = () => {
            this.hovering = false;
            this.start();
          };
          this.onFocusIn = () => {
            this.focused = true;
            this.stop();
          };
          this.onFocusOut = (event) => {
            if (this.contains(event.relatedTarget)) return;
            this.focused = false;
            this.start();
          };
          this.onSelect = (event) => {
            const selected = event.target.closest('[data-announcement-message]');
            if (!selected || !this.contains(selected)) return;
            this.editorPaused = true;
            this.stop();
            this.querySelectorAll('[data-announcement-message]').forEach((message) => {
              const active = message === selected;
              message.classList.toggle('is-active', active);
              if (active) {
                message.removeAttribute('aria-hidden');
              } else {
                message.setAttribute('aria-hidden', 'true');
              }
            });
            const next = this.messages.indexOf(selected);
            if (next !== -1) this.index = next;
          };
          this.onDeselect = (event) => {
            if (!this.contains(event.target)) return;
            this.editorPaused = false;
            if (this.messages.length > 0) this.show(this.index);
            this.start();
          };

          this.addEventListener('mouseenter', this.onEnter);
          this.addEventListener('mouseleave', this.onLeave);
          this.addEventListener('focusin', this.onFocusIn);
          this.addEventListener('focusout', this.onFocusOut);
          document.addEventListener('shopify:block:select', this.onSelect);
          document.addEventListener('shopify:block:deselect', this.onDeselect);

          this.start();
        }

        disconnectedCallback() {
          this.stop();
          this.removeEventListener('mouseenter', this.onEnter);
          this.removeEventListener('mouseleave', this.onLeave);
          this.removeEventListener('focusin', this.onFocusIn);
          this.removeEventListener('focusout', this.onFocusOut);
          document.removeEventListener('shopify:block:select', this.onSelect);
          document.removeEventListener('shopify:block:deselect', this.onDeselect);
        }

        paused() {
          return this.hovering || this.focused || this.editorPaused;
        }

        start() {
          if (this.paused()) return;
          if (this.messages.length < 2) return;
          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
          this.stop();
          this.timer = window.setInterval(() => {
            this.show((this.index + 1) % this.messages.length);
          }, this.seconds * 1000);
        }

        stop() {
          if (!this.timer) return;
          window.clearInterval(this.timer);
          this.timer = null;
        }

        show(next) {
          const activeMessage = this.messages[next];
          this.querySelectorAll('[data-announcement-message]').forEach((message) => {
            const active = message === activeMessage;
            message.classList.toggle('is-active', active);
            if (active) {
              message.removeAttribute('aria-hidden');
            } else {
              message.setAttribute('aria-hidden', 'true');
            }
          });
          this.index = next;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
